/**
* filters Module
*
* Description
*/
var app = angular.module('filters', []);


    require('./currencyuah.filter.js');
    require('./capitalize.filter.js');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/filters/index.js
 ** module id = 245
 ** module chunks = 1
 **/